import { render, staticRenderFns } from "./StaffForm.vue?vue&type=template&id=65f1cf63&scoped=true&"
import script from "./StaffForm.vue?vue&type=script&lang=js&"
export * from "./StaffForm.vue?vue&type=script&lang=js&"
import style0 from "./StaffForm.vue?vue&type=style&index=0&id=65f1cf63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f1cf63",
  null
  
)

export default component.exports